import { QueryClient } from '@tanstack/react-query';

/**
 * 4xx 是"重试也不会变好"的失败（校验错误、未登录、限流），5xx 与网络错误才值得重试。
 * 这里用结构化判断（duck typing）而不是 import ApiError，避免 lib 层反向依赖 api 层。
 */
function isNonRetryable(error: unknown): boolean {
  const status = (error as { status?: unknown } | null)?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
}

/**
 * TanStack Query 全局配置。
 *
 * - `retry`：只对"可能自己好起来"的失败重试（网络错误、5xx）；4xx 一律不重试，
 *   否则登录失败会被重试三次，用户看到三个报错；
 * - `staleTime`：默认 30 秒内不重复拉取，减少无谓请求；
 * - `refetchOnWindowFocus`：关闭 —— 阅读/复习场景频繁切窗口，不该每次都刷。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isNonRetryable(error)) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
